import * as React from 'react';
import { DragData, Droppable, DraggableItemTypes } from 'owa-dnd';
import { dropMailItem } from '../actions/dropActions';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { observer } from 'mobx-react-lite';
import { getDayViewDropTimeMinuteOffset } from 'owa-time-panel-dnd';
import { getSelectedView } from 'owa-calendar-list-settings';
import { getDropBoxDropState } from '../selectors/timePanelDndStoreSelectors';
import { setDayViewDropTimeMinuteOffset } from 'owa-time-panel-dnd';
import { OwaDate, addMinutes } from 'owa-datetime';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';

export interface CalendarCreateDroppableProps {
    classNames?: string;
    children?: React.ReactNode;
    selectedDate?: OwaDate;
}

/**
 * This component handles creating a meeting from items dropped on it.
 * For now, that's creating a meeting from email messages.
 */
const CalendarCreateDroppable: React.FunctionComponent<CalendarCreateDroppableProps> = observer(
    function CalendarCreateDroppable(props: CalendarCreateDroppableProps) {
        const { classNames, children, selectedDate } = props;
        const dropViewState = getDropBoxDropState();

        const onCalendarDropCallback = React.useCallback(
            (dragData: DragData, pageX: number, pageY: number, target?: HTMLElement) => {
                onCalendarDrop(dragData, pageX, pageY, target, selectedDate);
            },
            [selectedDate]
        );

        return (
            <Droppable
                dropViewState={dropViewState}
                canDrop={canCalendarDrop}
                onDrop={onCalendarDropCallback}
                classNames={classNames}
                greedy={true}>
                {children}
            </Droppable>
        );
    }
);

function onCalendarDrop(
    dragData: DragData,
    pageX: number,
    pageY: number,
    target?: HTMLElement,
    selectedDate?: OwaDate
): void {
    switch (dragData.itemType) {
        case DraggableItemTypes.MailListRow:
            const mailListDragData = dragData as MailListRowDragData;
            switch (getSelectedView()) {
                case 'Agenda':
                    dropMailItem(
                        mailListDragData,
                        'TimePanel_DragToAgendaReplyWithMeeting',
                        'AgendaViewDropBox',
                        selectedDate && getDefaultStart(selectedDate)
                    );
                    break;
                case 'Day':
                    dropMailItem(
                        mailListDragData,
                        'TimePanel_DragToDayReplyWithMeeting',
                        'DayViewSchedulingGrid',
                        selectedDate && addMinutes(selectedDate, getDayViewDropTimeMinuteOffset())
                    ); //manually set time by drop location
                    setDayViewDropTimeMinuteOffset(null);
                    break;
            }
            break;
    }
}

function canCalendarDrop(dragInfo: DragData): boolean {
    return dragInfo.itemType === DraggableItemTypes.MailListRow;
}

export default CalendarCreateDroppable;
